<script>
// CommitChart.js
import { Bar } from 'vue-chartjs'

export default {
  name: 'StackedBarGraph',
  extends: Bar,
  props: {
    data: Object,
    title: String,
  },
  mounted () {
    const options = {
      scales: {
        xAxes: [{
          stacked: true,
          ticks: {
            fontSize: 20,
            fontColor: 'black'
          }
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            fontSize: 20,
            fontColor: 'black'
          }
        }]
      },
      legend: {
        labels: {
          fontColor: 'black',
          defaultFontColor: 'black'
        }
      }
    }
    this.renderChart(this.data, options)
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// StackedBarGraph.vue?64a57b41